module.exports = ":host {\n    overflow:auto;\n}\n\n.api-title h4 {\n    text-align: center;\n    background-color: #186BA0;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 10px;\n    color: white;\n    border-radius: 3px;\n}\n\n.api-title{\n    position: relative;\n}\n.api-title .fa-info-circle {\n    position:absolute;\n    color: white;\n    top: 12px;\n    right: 18px;\n    font-size: 1.2em;\n}\n\n:host .info-overlay-target {\n    position: absolute;\n    left: 305px;\n    top: 61px;\n}\n:host >>> .ui-overlaypanel {\n    position:fixed;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/sidebar/sidebar.css
 ** module id = 764
 ** module chunks = 0
 **/